import React from 'react';
import { Modal, Form, Button, Input } from 'antd'

const AUTH_MODE = {
	signIn: 0,
	signUp: 1
}

export default class CodeVerificationModal extends React.Component {

    state = {
        verificationCode: ""
    }
    
    handleSubmit = async () => {
        let done;
        if(this.props.signInMode === AUTH_MODE.signIn){
            done = await this.props.authWithPhone(this.state.verificationCode);
        } else {
            done = await this.props.signUpWithPhone(this.state.verificationCode);
        }

        if(done){
            this.handleCancel();
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

	handleCancel = () => {
		this.resetForm();
        this.props.onCancel();
	}

	resetForm = () => {
	}
    
    render(){
        return (
            <Modal
                className='login_block'
                visible={this.props.visible}
                okText='Recover'
                onCancel={this.handleCancel}
                footer={null}
                    >
                        <div className='modalPayment'>
                            <div className='signInDescription'>
                                Please enter the verification code sent to your number
                            </div>
                            <div className='loginForm'>
                                <Form
                                    ref={this.props.formRef}
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ span: 12 }}
                                    onFinish={this.handleSubmit}
                                >
                                    <div className='centralButton'>
                                        <Form.Item
                                            name="verificationCode"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input the six digit code!',
                                                min: 6,
                                                max: 6
                                            },
                                            ]}
                                        >
                                            <Input
                                                type="text"
                                                value={this.verificationCode}
                                                onChange={this.handleChange}
                                                name="verificationCode"
                                                id="verificationCode"
                                                style={{
                                                    width: '100%',
                                                }}
                                            />
                                        </Form.Item> 
                                    </div>
                                    <div className='centralButton' style={{marginTop: 30}}>
                                        <Form.Item>
                                            <Button
                                                className='coinButton profileApply'
                                                type='primary'
                                                htmlType='submit'
                                            >
                                                Confirm
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </Modal>
        );
    }
}